var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { getResponsiveRules, parseThemePath } from '@axs/axsui-theme';
import classnames from 'classnames';
var Div = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  background-image: ", ";\n  border-color: ", ";\n  border-style: ", ";\n  border-radius: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  border-width: ", ";\n  bottom: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  cursor: ", ";\n  ", ";\n  font-family: ", ";\n  ", ";\n  font-weight: ", ";\n  height: ", ";\n  left: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  max-height: ", ";\n  max-width: ", ";\n  opacity: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  pointer-events: ", ";\n  position: ", ";\n  right: ", ";\n  text-align: ", ";\n  text-transform: ", ";\n  top: ", ";\n  ", ";\n  z-index: ", ";\n"], ["\n  background: ", ";\n  background-image: ", ";\n  border-color: ", ";\n  border-style: ", ";\n  border-radius: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  border-width: ", ";\n  bottom: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  cursor: ", ";\n  ", ";\n  font-family: ", ";\n  ", ";\n  font-weight: ", ";\n  height: ", ";\n  left: ", ";\n  letter-spacing: ", ";\n  line-height: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  max-height: ", ";\n  max-width: ", ";\n  opacity: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  pointer-events: ", ";\n  position: ", ";\n  right: ", ";\n  text-align: ", ";\n  text-transform: ", ";\n  top: ", ";\n  ", ";\n  z-index: ", ";\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor, theme = _a.theme;
    return backgroundColor && parseThemePath(backgroundColor, theme, 'transparent');
}, function (_a) {
    var backgroundImage = _a.backgroundImage;
    return backgroundImage && "url(".concat(backgroundImage, ")");
}, function (_a) {
    var border = _a.border, borderColor = _a.borderColor, theme = _a.theme;
    return (border || borderColor) && parseThemePath(borderColor, theme, '#eeeeee');
}, function (_a) {
    var border = _a.border, borderStyle = _a.borderStyle;
    return (borderStyle || border) && border ? 'solid' : borderStyle && borderStyle;
}, function (_a) {
    var borderRadius = _a.borderRadius, theme = _a.theme;
    return borderRadius && parseThemePath(borderRadius, theme, '0');
}, function (_a) {
    var borderRadiusBottomLeft = _a.borderRadiusBottomLeft, theme = _a.theme;
    return borderRadiusBottomLeft &&
        "border-bottom-left-radius:\n    ".concat(parseThemePath(borderRadiusBottomLeft, theme, 'unset'));
}, function (_a) {
    var borderRadiusTopLeft = _a.borderRadiusTopLeft, theme = _a.theme;
    return borderRadiusTopLeft &&
        "border-top-left-radius:\n    ".concat(parseThemePath(borderRadiusTopLeft, theme, 'unset'));
}, function (_a) {
    var borderRadiusBottomRight = _a.borderRadiusBottomRight, theme = _a.theme;
    return borderRadiusBottomRight &&
        "border-bottom-right-radius:\n    ".concat(parseThemePath(borderRadiusBottomRight, theme, 'unset'));
}, function (_a) {
    var borderRadiusTopRight = _a.borderRadiusTopRight, theme = _a.theme;
    return borderRadiusTopRight &&
        "border-top-right-radius:\n    ".concat(parseThemePath(borderRadiusTopRight, theme, 'unset'));
}, function (_a) {
    var borderWidth = _a.borderWidth, border = _a.border;
    return (borderWidth || (border && border) ? '1px' : borderWidth);
}, function (_a) {
    var bottom = _a.bottom;
    return bottom;
}, function (_a) {
    var boxShadow = _a.boxShadow, theme = _a.theme;
    return boxShadow && parseThemePath(boxShadow, theme, 'none');
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color && parseThemePath(color, theme, 'inherit');
}, function (_a) {
    var cursor = _a.cursor;
    return cursor;
}, function (_a) {
    var display = _a.display, inline = _a.inline;
    return (inline ? 'display: inline-block' : getResponsiveRules('display', display));
}, function (_a) {
    var fontFamily = _a.fontFamily;
    return fontFamily;
}, function (_a) {
    var fontSize = _a.fontSize;
    return fontSize && getResponsiveRules('font-size', fontSize);
}, function (_a) {
    var fontWeight = _a.fontWeight;
    return fontWeight;
}, function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var left = _a.left;
    return left;
}, function (_a) {
    var letterSpacing = _a.letterSpacing;
    return (letterSpacing ? letterSpacing : 'normal');
}, function (_a) {
    var lineHeight = _a.lineHeight;
    return lineHeight;
}, function (_a) {
    var minHeight = _a.minHeight;
    return minHeight;
}, function (_a) {
    var minWidth = _a.minWidth;
    return minWidth;
}, function (_a) {
    var maxHeight = _a.maxHeight;
    return maxHeight;
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth;
}, function (_a) {
    var opacity = _a.opacity;
    return opacity;
}, function (_a) {
    var margin = _a.margin;
    return margin && getResponsiveRules('margin', margin);
}, function (_a) {
    var marginTop = _a.marginTop;
    return marginTop && getResponsiveRules('margin-top', marginTop);
}, function (_a) {
    var marginBottom = _a.marginBottom;
    return marginBottom && getResponsiveRules('margin-bottom', marginBottom);
}, function (_a) {
    var marginLeft = _a.marginLeft;
    return marginLeft && getResponsiveRules('margin-left', marginLeft);
}, function (_a) {
    var marginRight = _a.marginRight;
    return marginRight && getResponsiveRules('margin-right', marginRight);
}, function (_a) {
    var padding = _a.padding;
    return padding && getResponsiveRules('padding', padding);
}, function (_a) {
    var paddingTop = _a.paddingTop;
    return paddingTop && getResponsiveRules('padding-top', paddingTop);
}, function (_a) {
    var paddingBottom = _a.paddingBottom;
    return paddingBottom && getResponsiveRules('padding-bottom', paddingBottom);
}, function (_a) {
    var paddingLeft = _a.paddingLeft;
    return paddingLeft && getResponsiveRules('padding-left', paddingLeft);
}, function (_a) {
    var paddingRight = _a.paddingRight;
    return paddingRight && getResponsiveRules('padding-right', paddingRight);
}, function (_a) {
    var padded = _a.padded;
    return padded && 'padding: 20px';
}, function (_a) {
    var pointerEvents = _a.pointerEvents;
    return pointerEvents;
}, function (_a) {
    var position = _a.position;
    return position;
}, function (_a) {
    var right = _a.right;
    return right;
}, function (_a) {
    var textAlign = _a.textAlign;
    return textAlign;
}, function (_a) {
    var textTransform = _a.textTransform;
    return textTransform;
}, function (_a) {
    var top = _a.top;
    return top;
}, function (_a) {
    var width = _a.width;
    return width && getResponsiveRules('width', width);
}, function (_a) {
    var zIndex = _a.zIndex;
    return zIndex;
});
export var AXSBlock = React.forwardRef(function (_a, ref) {
    var as = _a.as, inline = _a.inline, props = __rest(_a, ["as", "inline"]);
    return (React.createElement(Div, __assign({}, props, { as: inline ? 'span' : as ? as : 'div', className: classnames(['c-axs-block', props.className]), ref: ref })));
});
var templateObject_1;
